import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import ServiceTypeExtraTable, {
  SERVICE_TYPE_EXTRA_COLUMNS, SERVICE_TYPE_EXTRA_CARDS, SERVICE_TYPE_EXTRA_MIN_TABLE_WIDTH
} from 'components/Tables/ServiceTypeExtra';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'serviceTypeExtraStore') @observer
class ServiceTypeExtraIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      serviceTypeExtraStore,
      serviceTypeExtraStore: {
        serviceTypeExtra: {
          isLoading,
          isError
        }
      }, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={SERVICE_TYPE_EXTRA_COLUMNS}
          cards={SERVICE_TYPE_EXTRA_CARDS}
          minTableWidth={SERVICE_TYPE_EXTRA_MIN_TABLE_WIDTH}
          noun="extras"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="extras" onRetry={() => serviceTypeExtraStore.loadServiceTypeExtras()} />;
    }
    if (!isError && !isLoading) {
      content = <ServiceTypeExtraTable />
    }
    return (
      <div>
        <Helmet>
          <title>Service Type Extra | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.ServiceTypeExtraSearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default ServiceTypeExtraIndexPage;